import React from "react";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import SelectMultipleField from "../../../../FormControl/input/SelectMultipleField";

const FormCurriculumElements = ({ onChangeAlert, formData = {}, currentCurriculum }) => {
  const [form, setInputForm] = React.useState(formData);

  if (
    !currentCurriculum ||
    !currentCurriculum?.elements ||
    !currentCurriculum.elementsStructure
  )
    return <></>;
  const onChange = (name, value) => {
    let formData = { ...form };

    if (name === "elementId") {
      formData = { ...form, subElementId: null, [name]: value };
    } else {
      formData = { ...form, [name]: value };
    }
    setInputForm(formData);
    onChangeAlert("curriculumelements", formData);
  };

  const element = currentCurriculum?.elements;
  const elementChildren = form.elementId?.value?.length === 1 ? element?.children?.find(
    (item) => item._id === form.elementId?.value[0]
  ) : null;

  const subElement = elementChildren?.elements[0];

  return (
    <>
      <Typography
        variant="inherit"
        className="font-bold capitalize"
        color="primary"
        align="right"
        component="p"
      >
        {currentCurriculum.elementsStructure?.name}
      </Typography>
      <div className="col-span-3">
        <SelectMultipleField
          id={`elementId-${element?.elementStructureId}`}
          name="elementId"
          value={form.elementId?.value || []}
          onChange={(e) =>
            onChange("elementId", {
              key: element?.elementStructureId,
              value: e.target.value,
              keyName: currentCurriculum.elementsStructure?.name,
              valueName: element?.children?.filter(
                (item) => e.target.value.includes(item._id)
              )?.map((item) => item.name),
            })
          }
          options={
            element.children?.map((item) => ({
              value: item._id,
              label: item.name,
            })) || []
          }
          placeholder="Choose an option"
        />
      </div>
      {subElement && currentCurriculum.elementsStructure?.children[0] && (
        <>
          <Typography
            variant="inherit"
            className="font-bold capitalize"
            color="primary"
            align="right"
            component="p"
          >
            {currentCurriculum.elementsStructure?.children[0]?.name}
          </Typography>
          <div className="col-span-3">
            <SelectMultipleField
              id={`subElementId-${currentCurriculum.elementsStructure?.children[0]?._id}`}
              name="subElementId"
              value={form.subElementId?.value || ""}
              onChange={(e) =>
                onChange("subElementId", {
                  key: subElement?.elementStructureId,
                  keyName: currentCurriculum.elementsStructure?.children[0]?.name,
                  value: e.target.value,
                  valueName: subElement?.children?.filter(
                    (item) => e.target.value.includes(item._id)
                  )?.map((item) => item.name),
                })
              }
              options={
                subElement?.children?.map((item) => ({
                  value: item._id,
                  label: item.name,
                })) || []
              }
              placeholder="Choose an option"
            />
          </div>
        </>
      )}
    </>
  );
};

export default FormCurriculumElements;
